var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRating5Dark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312f2f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 1,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9211",
    "data-name": "Group 9211",
    transform: "translate(-3625 -10364)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_443",
    "data-name": "Ellipse 443",
    cx: 37,
    cy: 37,
    r: 37,
    transform: "translate(3625 10364)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_448",
    "data-name": "Ellipse 448",
    cx: 34,
    cy: 34,
    r: 34,
    transform: "translate(3628 10367)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9175",
    "data-name": "Group 9175",
    transform: "translate(3639.973 10389.649)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8894",
    "data-name": "Path 8894",
    d: "M1699.609,38.752a.713.713,0,0,1-.777.058c-5.926-3.265-12.331-1.6-13.722-1.331a.726.726,0,0,1-.135.013.707.707,0,0,1-.637-.4c-.176-.366.049-.7.366-.96,1.019-.823,7.658-6.383,15,1.56a.721.721,0,0,1-.092,1.063",
    transform: "translate(-1684.276 -33.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8895",
    "data-name": "Path 8895",
    d: "M1829.244,38.752a.713.713,0,0,0,.777.058c5.926-3.265,12.331-1.6,13.721-1.331a.727.727,0,0,0,.135.013.707.707,0,0,0,.637-.4c.176-.366-.049-.7-.366-.96-1.019-.823-7.658-6.383-15,1.56a.721.721,0,0,0,.092,1.063",
    transform: "translate(-1800.26 -33.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8896",
    "data-name": "Path 8896",
    d: "M1728.869,126.309s2.162,9.651,13.312,9.651a13.224,13.224,0,0,0,13.312-9.651Z",
    transform: "translate(-1720.023 -107.893)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating5Dark);
export default __webpack_public_path__ + "static/media/rating_5_dark.ffcd208686bc9260c02e93f20b96a46f.svg";
export { ForwardRef as ReactComponent };